@if (update.available() || update.updating()) {
@if (corner) {
<button type="button" class="upd-corner" [class.busy]="update.updating()" [disabled]="update.updating()"
  (click)="update.apply()"
  [attr.aria-label]="update.updating() ? 'Loading the new version of Link' : 'A new version of Link is ready. Update now'"
  [title]="update.updating() ? 'Loading the new version…' : 'A new version of Link is ready — tap to update. It takes a second.'">
  <span class="upd-corner-logo" aria-hidden="true">
    <img src="../../../assets/login/header-logo.png" alt="" />
    <span class="upd-corner-badge"><span class="material-symbols-outlined">refresh</span></span>
  </span>
  <span class="upd-corner-text">
    <b>{{ update.updating() ? 'Updating…' : 'Update' }}</b>
    <small>{{ update.updating() ? 'Loading the new Link' : 'A new Link is ready' }}</small>
  </span>
</button>
} @else {
<button type="button" class="upd" [class.floating]="floating" [class.busy]="update.updating()"
  [disabled]="update.updating()" (click)="update.apply()"
  [attr.aria-label]="update.updating() ? 'Loading the new version of Link' : 'A new version of Link is ready. Update now'"
  [title]="update.updating() ? 'Loading the new version…' : 'A new version of Link is ready — click to update. It takes a second; nothing you saved is lost.'">
  <span class="upd-ring" aria-hidden="true"></span>
  <span class="material-symbols-outlined upd-icon" aria-hidden="true">refresh</span>
  <span class="upd-text">{{ update.updating() ? 'Updating…' : 'Update' }}</span>
</button>
}
}
